import * as t from "io-ts";
import { DateFromISOString } from "io-ts-types/lib/DateFromISOString";

import { BillingAddress, ShippingAddress } from "./address";
import { OrderAPIURL, OrderNumber } from "./nominals";

const OrderCancellationReason = t.readonly(
    t.type({
        reason: t.string,
    }),
);

export const OrderCancellationInfo = t.readonly(
    t.type({
        number: t.string,
        status: t.string,
        date_placed: DateFromISOString,
        can_be_cancelled: t.boolean,
        cancellation_window_ends_on: DateFromISOString,
        cancellation_reasons: t.readonlyArray(OrderCancellationReason),
    }),
);

export type OrderCancellationInfo = t.TypeOf<typeof OrderCancellationInfo>;

const OrderDiscount = t.readonly(
    t.type({
        description: t.string,
        name: t.string,
        amount: t.string,
    }),
);

const Order = t.readonly(
    t.type({
        url: OrderAPIURL,
        number: OrderNumber,
        basket: t.string,
        lines: t.string,
        owner: t.string,
        billing_address: BillingAddress,
        currency: t.string,
        total_incl_tax: t.string,
        total_excl_tax: t.string,
        shipping_incl_tax: t.string,
        shipping_excl_tax: t.string,
        shipping_address: ShippingAddress,
        shipping_method: t.string,
        shipping_code: t.string,
        status: t.string,
        email: t.string,
        date_placed: t.string,
        payment_url: t.string,
        offer_discounts: t.readonlyArray(OrderDiscount),
        voucher_discounts: t.readonlyArray(t.string), // TODO: spec
        surcharges: t.readonlyArray(t.string), // TODO: spec
    }),
);

type Order = t.TypeOf<typeof Order>;

export const OrderList = t.readonlyArray(Order);
export type OrderList = t.TypeOf<typeof OrderList>;
